var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.091,
    height: 21.281,
    viewBox: "0 0 20.091 21.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "noun_Search_2475045",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M70.7,70.462a1.02,1.02,0,0,0-1.5,1.377L72.376,75.3a1.02,1.02,0,0,0,1.5-1.377Z",
    transform: "translate(-54.057 -54.355)",
    fill: "#f14136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M28.008,19.489a1.02,1.02,0,0,0-1.966-.543,6.817,6.817,0,1,1-.905-5.61,1.02,1.02,0,0,0,1.7-1.135,8.854,8.854,0,1,0,1.176,7.288Z",
    transform: "translate(-10.599 -8.263)",
    fill: "#f14136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M73.338,32.894a1.02,1.02,0,1,0-1.986.462,2.654,2.654,0,0,1,.069.423l.015.161a1.02,1.02,0,0,0,1.012.91c.036,0,.074,0,.11-.005a1.02,1.02,0,0,0,.905-1.125l-.015-.145A4.32,4.32,0,0,0,73.338,32.894Z",
    transform: "translate(-55.841 -26.026)",
    fill: "#f14136"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d64da7aa01cd938e91008a6b35a82625.svg";
export { ForwardRef as ReactComponent };